import PropertyImg_1 from "../../../images/search-result/property-img.jpg";
import PropertyImg_2 from "../../../images/search-result/property-img2.jpg";
import PropertyImg_3 from "../../../images/search-result/property-img3.jpg";
import PropertyImg_4 from "../../../images/search-result/property-img4.jpg";
import PropertyImg_5 from "../../../images/search-result/property-img5.jpg";
import PropertyImg_6 from "../../../images/search-result/property-img6.jpg";
import AgentPic from "../../../images/agent-pic.jpg";
export const PropertyList = [
    {
        PropertyImg: PropertyImg_1,
        PhotoNumber: '1/4', 
        PropertyText: '4 bedroom detached house for sale',
        PropertyTitle: 'Rookery Lane,\nWolverhampton, WV2 4PY',
        PropertyPrice: 'Offers over £350,000',
        BedCount: '4',
        BathCount: '2',
        RecCount: '1',
        PropertyInfoFirst:' A fine family home in a sought after area with extensive accommodation and a charming mature garden.',
        PropertyInfoSecond:'Located within a popular address, standing in an established residential area within easy reach of a wide range of amenities and facilities, there is easy access to the City Centre, M6/M5 motorway links for a commuter and the area is well served by schooling.',
        AgentImg:AgentPic,
        AgentName: 'Steve Dunham',
        AgentNumber: '07891 219 283',
    },
    {
        PropertyImg: PropertyImg_2,
        PhotoNumber: '1/4',
        PropertyText: '5 bedroom detached house for sale',
        PropertyTitle: 'Kings Road, \nCalf Heath, WV10 7DU',
        PropertyPrice: '£425,000',
        BedCount: '5',
        BathCount: '2',
        RecCount: '1',
        PropertyInfoFirst:' This stunning, five bedroom, executive style home is set in the delightful village of Calf Heath with the canal just a stones throw away!',
        PropertyInfoSecond:'The spacious hallway with guest W.C off hosts the dining room, lounge with feature fireplace and patio doors leading to the conservatory, study and stylish kitchen/breakfast room with useful utility off.',
        AgentImg:AgentPic,
        AgentName: 'Steve Dunham',
        AgentNumber: '07891 219 283',
    },
    {
        PropertyImg: PropertyImg_3,
        PhotoNumber: '1/4',
        PropertyText: '3 bedroom detached house for sale',
        PropertyTitle: 'St. Philips Avenue, \nWolverhampton, WV3 7DU',
        PropertyPrice: '£295,000',
        BedCount: '3',
        BathCount: '2',
        RecCount: '1',
        PropertyInfoFirst:' A beautifully presented and most attractive "Mock Tudor" designed THREE BEDROOM double fronted detached family residence, retaining many original features yet incorporating certain modern and contemporary improvements throughout and standing in a fine and sought after residential location.',
        PropertyInfoSecond:'',
        AgentImg:AgentPic,
        AgentName: 'Steve Dunham',
        AgentNumber: '07891 219 283',
    },
    {
        PropertyImg: PropertyImg_4,
        PhotoNumber: '1/4',
        PropertyText: '4 bedroom detached house for sale',
        PropertyTitle: 'Mercia Drive, \nWolverhampton, WV6 7NH',
        PropertyPrice: 'Offers over £280,000',
        BedCount: '4',
        BathCount: '2',
        RecCount: '1',
        PropertyInfoFirst:' A fine family home in a sought after area with extensive accommodation and a charming mature garden. Located within a popular address, standing in an established residential area within easy reach of a wide range of amenities and facilities.',
        PropertyInfoSecond:'',
        AgentImg:AgentPic,
        AgentName: 'Steve Dunham',
        AgentNumber: '07891 219 283',
    },
    {
        PropertyImg: PropertyImg_5,
        PhotoNumber: '1/4',
        PropertyText: '5 bedroom detached house for sale',
        PropertyTitle: 'Elm Road, \nAlbrighton, WV7 3LN',
        PropertyPrice: '£250,000',
        BedCount: '5',
        BathCount: '2',
        RecCount: '1',
        PropertyInfoFirst:'This stunning, five bedroom, executive style home is set in the delightful village of Calf Heath with the canal just a stones throw away!',
        PropertyInfoSecond:'The spacious hallway with guest W.C off hosts the dining room, lounge with feature fireplace and patio doors leading to the conservatory, study and stylish kitchen/breakfast room with useful utility off.',
        AgentImg:AgentPic,
        AgentName: 'Steve Dunham',
        AgentNumber: '07891 219 283',
    },
    {
        PropertyImg: PropertyImg_6,
        PhotoNumber: '1/4',
        PropertyText: '3 bedroom detached house for sale',
        PropertyTitle: 'Ranger Drive, \nWolverhampton, WV10 6DB',
        PropertyPrice: '£250,000',
        BedCount: '3',
        BathCount: '2',
        RecCount: '1',
        PropertyInfoFirst:' A beautifully presented and most attractive "Mock Tudor" designed THREE BEDROOM double fronted detached family residence, retaining many original features yet incorporating certain modern and contemporary improvements throughout and standing in a fine and sought after residential location.',
        PropertyInfoSecond:'',
        AgentImg:AgentPic,
        AgentName: 'Steve Dunham',
        AgentNumber: '07891 219 283',
    },
]